import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, Question } from '../api/client';
import { formatShortDate } from '../utils/date';

const QuestionList: React.FC = () => {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadQuestions();
  }, []);

  const loadQuestions = async () => {
    try {
      setLoading(true);
      const data = await api.listQuestions();
      setQuestions(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load questions');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="question-list container">
      <div className="page-header">
        <h2>Your Questions</h2>
        <Link to="/questions/new" className="btn btn-primary">
          Create Question
        </Link>
      </div>
      {questions.length === 0 ? (
        <p className="empty-state">
          No questions yet. <Link to="/questions/new">Create one!</Link>
        </p>
      ) : (
        <div className="questions-grid">
          {questions.map((question) => (
            <Link
              key={question.id}
              to={`/questions/${question.id}`}
              className="question-card"
            >
              <h3>{question.title}</h3>
              {question.description && <p>{question.description}</p>}
              <div className="question-meta">
                <span className={question.is_public ? 'badge public' : 'badge personal'}>
                  {question.is_public ? 'Public' : 'Personal'}
                </span>
                <span className="date">
                  {formatShortDate(question.created_at)}
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuestionList;
